<template>
  <div class="themeArticleDetail"
       :class="IsPC?'pcStyle':''">
    <div v-html="html"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      html: '',
      contentStr: '',
      id: ''
    }
  },
  async created () {

    if (this.environment.isFengChao) {
      this.$cjc.showNavigation()

    }
    if (this.$route.query.name) {
      document.title = this.$route.query.name
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    if (this.$route.query.Subject_APP) {
      this.id = this.$route.query.id
    }
    await this.themeArticleDetail()
  },
  mounted () {
    let herf = window.location.origin + `/helpWebMobile/#/HistoryProject`
    // let herf = 'https://www.baidu.com/'
    let icon = window.location.origin + `/helpWebMobile/img/lsjl.png`
    console.log(herf, icon);
    if (this.$route.query.Subject_APP) {
      if (this.environment.isFengChao) {
        console.log(111);
        setTimeout(() => {
          console.log(herf);
          this.$cjc.apiSetupNav({
            "rightButton": {
              "title": "历史专题",
              "url": herf,
              icon: icon,
              nextPageTitle: '历史专题'
            }
          })
        }, 500);
      }
    }
  },
  computed: {
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ['Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod'
      ];
      var flag = true;
      for (var i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) != -1) {
          flag = false;
          break;
        }
      }
      return flag
    }
  },
  methods: {

    async themeArticleDetail () {
      const { data: { result, status, msg } } = await this.$store.dispatch('themeArticleDetail', {
        id: this.id
      })
      if (status === 1000) {
        if (result.articleType == 1) {
          this.defaultContent = JSON.parse(result.contentStr)
          this.contentStr = result.contentStr
          this.html = result.content
        } else if (result.articleType == 2) {
          this.assignGZHCardData = JSON.parse(result.content)
        } else if (result.articleType == 3) {
          this.ruleForm.http = result.content
        }
        // let div = document.getElementById('themeArticleDetail')
        // console.log(result.content);
        // div.innerHTML =result.content
        this.role_id = result.viewPermission

      } else {
        this.$Message.error(msg)
      }
      console.log(this.ruleForm);
      // console.log(data);
    },
  },
}
</script>

<style lang="scss" >
@import "@/styles/wangEditor/index.scss";
.pcStyle {
  margin: 20px auto;
  border-radius: 10px;
  padding: 15px;
  max-width: 677px;
  min-height: 800px;
  background-color: #fff;
}
.themeArticleDetail {
  padding: 15px;
  background-color: #fff;
  min-height: 100vh;
  width: 100vw;
  p {
    margin: 0;
    word-break: break-all;
  }
  p,
  li,
  td,
  th,
  blockquote {
    white-space: pre-wrap; /* 显示空格 */
  }

  /* 表格 */
  table {
    border-collapse: collapse;
  }
  table th,
  table td {
    border: 1px solid #ccc;
    min-width: 50px;
    height: 20px;
    text-align: left;
  }
  table th {
    background-color: #f1f1f1;
    text-align: center;
  }

  /* 代码块 */
  pre > code {
    display: block;
    border: 1px solid hsl(0, 0%, 91%);
    border-radius: 4px 4px;
    text-indent: 0;
    background-color: #fafafa;
    padding: 10px;
    font-size: 14px;
  }

  /* 引用 */
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 10px 10px;
    margin: 10px 0;
    background-color: #f1f1f1;
  }

  /* 列表 */
  ul,
  ol {
    margin: 10px 0 10px 20px;
  }

  /* 分割线 */
  hr {
    display: block;
    width: 90%;
    margin: 20px auto;
    border: 0;
    height: 1px;
    background-color: #ccc;
  }

  img {
    max-width: 100%;
  }
  video {
    width: 100%;
    max-width: 677px;
    padding: 0 10px;
  }
}
</style>
